import React from "react";
import { useTranslation } from "react-i18next";

export const ScheduleToolbar = ({ props, currentUser, onNewSchedule }) => {
  const { t } = useTranslation();

  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group">
        <button onClick={() => props.onNavigate("PREV")}>
          {t("Back")}
        </button>
        <button onClick={() => props.onNavigate("NEXT")}>
          {t("Next")}
        </button>
      </span>
      {currentUser === "admin" && (
        <button
          onClick={onNewSchedule}
          style={{ backgroundColor: "#29474d", color: "#fff" }}
        >
          {t("New Schedule")}
        </button>
      )}
      <span className="rbc-toolbar-label">{props.label}</span>
      <span className="rbc-btn-group">
        {props.views.map((view) => (
          <button
            key={view}
            onClick={() => props.onView(view)}
            className={view === props.view ? "rbc-active" : ""}
          >
            {t(view)}
          </button>
        ))}
      </span>
    </div>
  );
};
